import actionTypes from './actionTypes';

//public actions
const changePreviousSeasonValue = (season) => ({
    type: actionTypes.CHANGE_PREVIOUS_SEASON_VALUE,
    payload: {
        id: season.id,
        value: season.value,
        label: season.label,
        startDate: season.startDate,
        endDate: season.endDate
    }
});

const changeTeamSelection = (id, availableTeams, isChecked) => ({
    type: actionTypes.CHANGE_TEAM_SELECTION,
    payload: {
        teamId: id,
        availableTeams: availableTeams,
        isChecked: isChecked
    }
});

const changeDivisionSelection = (id, availableTeams, isChecked) => ({
    type: actionTypes.CHANGE_DIVISION_SELECTION,
    payload: {
        divisionId: id,
        availableTeams: availableTeams,
        isChecked: isChecked
    }
});

const changeConferenceSelection = (id, availableTeams, isChecked) => ({
    type: actionTypes.CHANGE_CONFERENCE_SELECTION,
    payload: {
        conferenceId: id,
        availableTeams: availableTeams,
        isChecked: isChecked
    }
});

const changeAllSelection = (id, availableTeams, isChecked) => ({
    type: actionTypes.CHANGE_ALL_SELECTION,
    payload: {
        id: id,
        availableTeams: availableTeams,
        isChecked: isChecked
    }
});

const selectIndividualTeam = (id, availableTeams, isChecked) => ({
    type: actionTypes.SELECT_INDIVIDUAL_TEAM,
    payload: {
        id: id,
        availableTeams: availableTeams
    }
});

const hydrateTeamFilter = (selectedTeams) => ({
    type: actionTypes.HYDRATE_TEAM_FILTER,
    payload: {
        selectedTeams: selectedTeams
    }
});

const toggleCalendarFilter = () => ({
    type: actionTypes.TOGGLE_CALENDAR_FILTER
});

const toggleTeamFilter = () => ({
    type: actionTypes.TOGGLE_TEAM_FILTER
});

const setGameListPreparingToScroll = preparingToScroll => ({
    type: actionTypes.SET_GAME_LIST_PREPARING_TO_SCROLL,
    payload: {
        preparingToScroll
    }
});

export default {
    changePreviousSeasonValue,
    changeTeamSelection,
    changeDivisionSelection,
    changeConferenceSelection,
    changeAllSelection,
    selectIndividualTeam,
    hydrateTeamFilter,
    toggleCalendarFilter,
    toggleTeamFilter,
    setGameListPreparingToScroll
}